import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center px-4 text-center">
      <Helmet>
        <title>Page not found | PetFlyCheck</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 className="text-3xl font-bold text-slate-900 mb-3">Page not found</h1>
      <p className="text-slate-600 mb-6">This page does not exist or has moved.</p>
      <Link to="/" className="text-blue-600 font-medium">Back to PetFlyCheck</Link>
    </div>
  );
}
